import React from 'react';
import { Progress } from 'semantic-ui-react';
import { useDispatch } from 'react-redux';
import { Container, Heading, ProgressBarContainer, SubHeading, TextWrapper } from './Style';
import { RFICardProps } from '../../screens/dashboard/interface';
import { RFI_EKYC_URL, RFI_URL } from '../../utils/constants';
import COLORS from '../../common/styles/color-pallete';
import { BLUE_WARNING_ICON, CHEVRON_RIGHT_LIGHT_ICON } from '@Images';
import { isJumioApplicable } from '../../screens/ekyc-rfi';
import { AppDispatch } from '../../store.type';
import { isJumioServiceAvailable } from '@Redux/actions/individual-user-flow/individual-user-flow-action';

export const RFICard = (props: RFICardProps): React.ReactElement<RFICardProps> => {
  const {
    title,
    subTitle,
    total,
    value,
    expiryDate,
    navigate,
    isExpiryDateAlreadyBreached,
    rfiList,
    countryCode
  } = props;
  const progressBarStyle = {
    backgroundColor: COLORS.lightestPink
  };

  const dispatch = useDispatch<AppDispatch>();

  const onWrapperClick = async () => {
    let redirectURL = RFI_URL;
    if (isJumioApplicable(countryCode) && rfiList?.[0]?.document_code === 'KYC_TYPE') {
      if (rfiList?.filter((rfi: any) => rfi?.document_code !== 'KYC_TYPE')?.length > 0) {
        const isJumioAvailable = await dispatch(isJumioServiceAvailable(countryCode, true));
        if (isJumioAvailable) redirectURL = RFI_EKYC_URL;
      } else redirectURL = RFI_EKYC_URL; //If no RIFs apart from KYC Type
    }
    navigate(redirectURL);
  };

  return (
    <Container onClick={onWrapperClick}>
      <img width={64} height={64} src={BLUE_WARNING_ICON} alt="error" className="errorIcon" />
      <div className="innerWrapper">
        <TextWrapper>
          <div className="headingContainer">
            <Heading>{title}</Heading>
            <SubHeading>{subTitle}</SubHeading>
          </div>
          <img alt="forward-arrow" className="forward-arrow" src={CHEVRON_RIGHT_LIGHT_ICON} />
        </TextWrapper>

        <ProgressBarContainer>
          <Progress
            value={value}
            total={total}
            size="small"
            style={progressBarStyle}
            className="progressBar"
          />
          {!isExpiryDateAlreadyBreached && (
            <div className="date">{expiryDate ? expiryDate : ''}</div>
          )}
        </ProgressBarContainer>
      </div>
    </Container>
  );
};
